<template>
    <div> 
        <div id="mainhold">
            <div class="colsL">
                <div class="lineWrapper">Articles | Highlights</div>
                <div class="section"></div>
            </div>
            <div class="colsR">
                <div class="lineWrapper">Post & Edit Articles</div>
                <div class="spacer"></div>
                <div class="section">
                    <input type="text" class="textbox" placeholder="Program" v-model="program">
                    <input type="text" class="textbox" placeholder="Title" v-model="title">
                    <textarea class="textview" v-model="articleText"></textarea>
                    <input type="text" class="textbox" placeholder="Region" v-model="region">
                    <input type="text" class="textbox" placeholder="Country" v-model="country">
                </div>
                <div class="section">
                    <input type="text" class="textbox" placeholder="Link" v-model="infoLink">
                </div>
                <div class="section">
                <select class="textbox" v-model="live">
                <option value="null">LIVE STAT</option>
                <option value='true'>TRUE</option>
                <option value='false'>FALSE</option>
                </select>
                <div class="section amTealregular">Publication Date: {{pubDate}}<br>
                <datepicker name="startDate" v-model="dateSelect.date"></datepicker>
                </div>
                </div>
                <div class="lineWrapper amTealregular" v-if="!isUploaded">Upload Highlight Image
                <div class="section">
                    <input type="file" ref="fileInput">
                </div>
                </div>
                <div class="lineWrapper amTealregular" v-if="!isUploaded">Upload Supporting Image 
                <div class="section">
                    <input type="file" ref="fileInput2">
                </div>
                </div>
                <div class="section">
                    <div class="clickbtn bgPink cpointer textcenter" v-if="!isUploaded" @click="uploadPics">Upload</div>
                    <div class="lineWrapper" v-if="isEditing">Current Image {{fsimg}}</div>
                </div>
                <div class="section">
                    <div class="wrap amMintregular">Audio Components</div>
                    <div class="wrap">
                        <input type="file" ref="fileinput1">
                        <input type="file" ref="fileinput2">
                    </div>
                </div>
                <div class="section">
                    <div class="clickbtn bgMint cpointer textcenter" @click="uploadAudio">SEND AUDIO</div>
                    <div class="clickbtn bgTeal cpointer textcenter" @click="saveArticle">SAVE</div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase/app';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import { resizeImage } from "../utils";
import 'firebase/functions'
import 'firebase/auth'
import 'firebase/firestore'
import db from '../main'
export default {
    name:"highlights",
    created(){
        this.fetchArticles()
    },
    data(){
        return {
            title:"",
            articleText: "",
            dateSelect: new Date(),
            infoLink: "",
            articles: [],
            article: {},
            fsimg: "",
            fsimg2: "",
            imgBlob: "",
            pubDate: "",
            uploadValue: "",
            isUploading: false,
            isUploaded: false,
            live: false,
            isExisting: false,
            program:"",
            isEditing: false,
            region:"",
            country:"",
            fsAudio1: "none",
            fsAudio2: "none",
            hasAudio: false,
            audioBlob1: "",
        }
    },
    methods: {
        showDetail(article){
            this.isEditing = true
            this.isUploaded = false,
            this.isUploading = false,
            this.fsimg = article.highlightIMG,
            this.pubDate = article.pubdate,
            this.live = article.live,
            this.region = article.region,
            this.country = article.country
            this.program = article.program,
            this.title = article.highlight_title,
            this.articleText = article.highlight_article
            this.infoLink = article.highlight_link
        },
        clearAll(){
            this.isEditing = false
            this.isUploaded = false
            this.isUploading = false
            this.fsimg = ""
            this.pubDate = ""
            this.article = {}
            this.live = ""
            this.region = ""
            this.program = ""
            this.title = ""
            this.infoLink = ""
            this.articleText = ""
        },
        saveArticle(){
            const pubdate = moment(this.dateSelect.date).format('LL')
            const pubInt = moment(this.dateSelect.date).unix()
            const highlightIMG = this.fsimg
            const highlightIMG2 = this.fsimg2
            const highlight_article = this.articleText
            const live = Boolean(this.live)
            const title = this.title
            const program = this.program
            const highlight_link = this.infoLink || null
            const region = this.region
            const audioPlus = Boolean(this.hasAudio)

            if (this.isEditing){
                const highlightID = this.article.highlightID
                const live = this.live
                const data = {
                    highlight_article: this.articleText,
                    highlight_title: this.title,
                    program: this.program,
                    live: Boolean(live),
                    country: this.country,
                    region: this.region,
                    highlight_link: this.infoLink,
                }

                db.collection("artscene_highlights").doc(highlightID).update(data).then(()=>{
                    this.clearAll()
                    this.fetchArticles()
                })

            } else {
                const newArticle = db.collection("artscene_highlights").doc()
                const data = {
                    pubdate: pubdate,
                    highlightIMG: highlightIMG,
                    highlightIMG2: highlightIMG2,
                    highlight_article: highlight_article,
                    highlight_title: title,
                    program: program,
                    live:live,
                    country:"US",
                    region: region,
                    highlight_link: highlight_link,
                    highlightID: newArticle.id,
                    pubInt: pubInt,
                    audioPlus: audioPlus,
                    voiceURL1: this.fsAudio1,
                    voiceURL2: this.fsAudio2
                }

                newArticle.set(data).then(() => {
                    this.clearAll()
                    this.fetchArticles()
                })
            }
            
        },
        uploadAudio(){
            const input = this.$refs.fileinput1;
            const files = input.files;
            if(files && files[0]){
                const soundFile = files && files[0]
                const fileref = "audioclip_" + this.title + ".mp3"
                const storageRef = firebase.storage().ref().child('audio').child(fileref).put(soundFile);
                storageRef.on(`state_changed`, snapshot => {
                    this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                }, error => {
                    alert(error.message);
                }, () => {
                    this.uploadValue = 100;
                    storageRef.snapshot.ref.getDownloadURL().then(audio1 => {
                        this.fsAudio1 = audio1
                        this.hasAudio = true
                        console.log("ALL DONE AUDIO 1")
                        this.uploadAudio2()
                    })
                })
            }
        },
        uploadAudio2(){
            const input = this.$refs.fileinput2;
            const files = input.files;
            if(files && files[0]){
                const soundFile = files && files[0]
                const fileref = "audioclip2_" + this.title + ".mp3"
                const storageRef = firebase.storage().ref().child('audio').child(fileref).put(soundFile);
                storageRef.on(`state_changed`, snapshot => {
                    this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                }, error => {
                    alert(error.message);
                }, () => {
                    this.uploadValue = 100;
                    storageRef.snapshot.ref.getDownloadURL().then(audio2 => {
                        this.fsAudio2 = audio2
                        console.log("ALL DONE AUDIO 2")
                    })
                })
            }
        },
        uploadPics() {
            const input = this.$refs.fileInput;
            const files = input.files;
            if(files && files[0]){
                resizeImage({
                    file:files[0],
                    sizes:[600]
                }).then(({blobs}) => {
                    this.imgBlob = blobs[0]
                    const fileref = "highlight_" + this.title + ".png"
                    if(this.imgBlob !== undefined){
                        const storageRef = firebase.storage().ref().child('highlightIMG').child(fileref).put(this.imgBlob);
                        storageRef.on('state_changed', snapshot => {
                            this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        }, error => {
                            alert(error.message);
                        }, () => {
                            this.uploadValue = 100;
                            storageRef.snapshot.ref.getDownloadURL().then(imgurl => {
                                this.fsimg = imgurl
                                this.imgBlob = null
                                this.isUploaded = true
                                console.log("UPLOADED WITH THIS LINK, ", imgurl)
                                this.uploadPics2()
                            })
                        })
                    }
                })
            }
        },
        uploadPics2() {
            const input = this.$refs.fileInput2;
            const files = input.files;
            if(files && files[0]){
                resizeImage({
                    file:files[0],
                    sizes:[600]
                }).then(({blobs}) => {
                    this.imgBlob = blobs[0]
                    const fileref = "highlight2_" + this.title + ".png"
                    if(this.imgBlob !== undefined){
                        const storageRef = firebase.storage().ref().child('highlightIMG').child(fileref).put(this.imgBlob);
                        storageRef.on('state_changed', snapshot => {
                            this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        }, error => {
                            alert(error.message);
                        }, () => {
                            this.uploadValue = 100;
                            storageRef.snapshot.ref.getDownloadURL().then(imgurl => {
                                this.fsimg2 = imgurl
                                console.log("UPLOADED WITH THIS LINK 2, ", imgurl)
                            })
                        })
                    }
                })
            }
        },
        fetchArticles(){
            this.articles = []
            db.collection("artscene_highlights").get().then(docs => {
                if (docs){
                    docs.forEach(doc => {
                        const data = doc.data()
                        this.articles.push(data)
                    })
                }
            })
        },
    },
    components: {
    'datepicker': Datepicker,  
    }
}
</script>

<style scoped>
#clickbtn {
    width: 100%;
    height: auto;
    padding: 2%;
    margin-top: 2%;
    float: left;
    clear: right;
}

#mainhold {
    width: 100%;
    height: 85vh;
    background-color: white;
    position: relative;
    overflow: scroll;
    margin-top: 50px;
}

.option {
    width: auto;
    height: auto;
    float: left;
    clear: right;
    padding: 1%;
    margin-right:5px;
    margin-bottom: 5px;
    cursor: pointer;
    color: white;
    background-color: teal;
}

.colsL {
    width: 30%;
    height: auto;
    float: left;
    clear: right;
    padding: 5%;
    border-right-color: #00a89d;
    border-right-width: 2px;
}

.colsR {
    width: 70%;
    height: auto;
    float: left;
    clear: right;
    padding: 5%;
    border-right-color: #00a89d;
    border-right-width: 2px;
}

.wrap {
    width: 100%;
    height: auto;
    margin-top: 2%;
    margin-bottom: 2%;
}

.exhibitList {
    width: 100%;
    height: auto;
    padding: 3%;
    background-color: aliceblue;
    border-radius: 1vmin;
    margin-bottom: 10px;
    float: left;
    clear: right;
    cursor: pointer;
}

.lineWrapper {
    width: 100%;
    height: auto;
    float: left;
    clear: right;
}

.textbox {
    width: 100%;
    height: auto;
    border-style: none;
    font-family: 'cocomatpro-regular';
    font-size: .85em;
    color: black;
    border-bottom-color: #00a89d;
    border-bottom-style: solid;
    border-bottom-width: 2px;
    margin-bottom: 10px;
}

.textview {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    border-style: none;
    font-family: 'cocomatpro-regular';
    font-size: .85em;
    color: black;
    border-bottom-color: #00a89d;
    border-bottom-style: solid;
    border-bottom-width: 2px;
    margin-bottom: 10px;
}
</style>